/* eslint-disable max-lines */
/* eslint-disable max-len */
import React from 'react';

interface TooltipProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.1646 8.64013C10.5636 8.64013 10.8871 8.96359 10.8871 9.36259V14.179C10.8869 14.5779 10.5635 14.9015 10.1646 14.9015C9.7657 14.9015 9.4423 14.5779 9.44214 14.179V9.36259C9.44214 8.96359 9.7656 8.64013 10.1646 8.64013Z"
      fill={props.color ?? props?.style?.color}
    />
    <path
      d="M10.1655 6.15102C10.6089 6.15102 10.9689 6.51104 10.9689 6.95438C10.9687 7.39758 10.6088 7.75681 10.1655 7.75681C9.72245 7.75664 9.36329 7.39747 9.36312 6.95438C9.36312 6.51115 9.72235 6.15119 10.1655 6.15102Z"
      fill={props.color ?? props?.style?.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1655 1.41549C14.9978 1.41549 18.9158 5.33276 18.916 10.165C18.9159 14.9973 14.9979 18.9155 10.1655 18.9155C5.33338 18.9153 1.41617 14.9972 1.41602 10.165C1.41618 5.33286 5.33339 1.41566 10.1655 1.41549ZM10.1655 2.86042C6.1314 2.86059 2.86111 6.13087 2.86094 10.165C2.8611 14.1992 6.13139 17.4704 10.1655 17.4706C14.1998 17.4706 17.4709 14.1993 17.4711 10.165C17.4709 6.13077 14.1998 2.86042 10.1655 2.86042Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Tooltip;
